import React from 'react';

const ProfileIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
      <path
        d="M20.2018 21.3C20.0852 21.2833 19.9352 21.2833 19.8018 21.3C16.8685 21.2 14.5352 18.8 14.5352 15.85C14.5352 12.8333 16.9685 10.3833 20.0018 10.3833C23.0185 10.3833 25.4685 12.8333 25.4685 15.85C25.4518 18.8 23.1352 21.2 20.2018 21.3Z"
        stroke="#867C79"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.2323 32.3001C28.2656 35.0168 24.3323 36.6668 19.999 36.6668C15.6656 36.6668 11.7323 35.0168 8.76562 32.3001C8.93229 30.7334 9.93229 29.2001 11.7156 28.0001C16.2823 24.9668 23.749 24.9668 28.2823 28.0001C30.0656 29.2001 31.0656 30.7334 31.2323 32.3001Z"
        stroke="#867C79"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.9987 36.6668C29.2034 36.6668 36.6654 29.2049 36.6654 20.0002C36.6654 10.7954 29.2034 3.3335 19.9987 3.3335C10.794 3.3335 3.33203 10.7954 3.33203 20.0002C3.33203 29.2049 10.794 36.6668 19.9987 36.6668Z"
        stroke="#867C79"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ProfileIcon;
